import { render, staticRenderFns } from "./TermsVue.vue?vue&type=template&id=f9c2eb74&scoped=true"
import script from "./TermsVue.vue?vue&type=script&lang=js"
export * from "./TermsVue.vue?vue&type=script&lang=js"
import style0 from "./TermsVue.vue?vue&type=style&index=0&id=f9c2eb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c2eb74",
  null
  
)

export default component.exports